import styled from "styled-components";

export const DropDownStyle = styled.div`
    transition: all 0.2s;
    width: 100%;
    color: #fff;
    border-radius: 8px;
    :hover {
        background-color: ${(props) => props.theme.secondary} !important;
    }
`

export const DropDownFixed = styled.div`
    background-color: ${(props) => props.theme.secondary};
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    width: 100%;
`
export const TextStyle = styled.div`
    color: ${(props) => props.theme.primary};
    width: 100%;
`

export const cardStyle = styled.div`
    .acordion-style {
        background-color: ${(props) => (props.theme.primary)} !important;
        color: #ffffff;
  }
`
